<template>
  <v-app>
    <v-main>
      <logout class="noprint" />
      <v-container v-if="loading" fill-height grid-list-md text-center ghost>
        <v-row wrap align-center>
          <v-col>
            Computation progress...
            <v-progress-linear
              color="light-blue accent-4"
              indeterminate
              rounded
              height="6"
            ></v-progress-linear>
          </v-col>
        </v-row>
      </v-container>
      <v-container ghost v-else>
        <iol-result-header :fields="results_header" />
        <v-row>
          <v-col class="col-12 col-md-6">
            <v-sheet
              v-if="['regular_od', 'regular_both'].includes(glastCalc)"
              class="iol-right-v-sheet"
            >
              <v-row class="justify-space-between">
                <h2 class="col-12 col-md-1">OD</h2>
                <iol-result-used-param
                  class="col-12 col-md-11"
                  :fields="common_inputs_od"
                />
              </v-row>
              <v-row>
                <iol-data-table-power
                  class="col-12"
                  :fields="results_table_od"
                />
              </v-row>
            </v-sheet>
          </v-col>
          <v-col cols="12" md="6">
            <v-sheet
              v-if="['regular_os', 'regular_both'].includes(glastCalc)"
              class="iol-left-v-sheet"
            >
              <v-row class="justify-space-between">
                <h2 class="col-12 col-md-1">OS</h2>
                <iol-result-used-param
                  class="col-12 col-md-11"
                  :fields="common_inputs_os"
                />
              </v-row>
              <v-row>
                <iol-data-table-power
                  class="col-12"
                  :fields="results_table_os"
                />
              </v-row>
            </v-sheet>
          </v-col>
        </v-row>
        <div class="noprint">
          <v-row>
            <v-col cols="12" class="text-center gray">
              <a @click="print" :style="resetstyle">Print</a>
            </v-col>
          </v-row>
          <br />
          <v-row>
            <v-col cols="12" class="text-center">
              <v-btn to="/regular" color="#3B4256" class="white--text" x-large
                >Modify Calculation</v-btn
              >
            </v-col>
            <v-col cols="12" class="text-center">
              <v-btn
                @click="submit_toric"
                color="#3B4256"
                class="white--text"
                :disabled="
                  (results_table_od.selected_power === null &&
                    results_table_os.selected_power === null) ||
                    (results_table_od.selected_power !== null &&
                      results_table_os.selected_power !== null)
                "
                x-large
              >
                Toric Calculation
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { mapState } from 'vuex'

import Logout from '@/vue/Logout.vue'
import IolResultHeader from '@/components/results/IolResultHeader.vue'
import IolDataTablePower from '@/components/results/IolDataTablePower.vue'
import IolResultUsedParam from '@/components/results/IolResultUsedParam.vue'

export default {
  name: 'Result',
  components: {
    Logout,
    IolDataTablePower,
    IolResultUsedParam,
    IolResultHeader,
  },
  data() {
    return {
      resetstyle: { color: '#838383' },
      loading: true,
      last_calc: '',
      results_header: {
        title: 'PEARL-DGS - Results - Regular Eyes',
        patientID: {
          label: 'Patient ID / Name',
          readonly: true,
          tooltip: '',
          text: '',
        },
        keratometric_index: {
          label: 'Keratometric Index',
          readonly: true,
          tooltip: '',
          text: '',
        },
        biometer: {
          label: 'biometer',
          readonly: true,
          tooltip: '',
          text: '',
        },
      },
      common_inputs_od: {
        al: '',
        k1: '',
        k2: '',
        acd: '',
        aconst_title: 'A Constant',
        aconst: '',
        target_title: 'Target refraction',
        target: '',
        lt: '',
        cct: '',
        inputs_type: 'regular',
      },
      common_inputs_os: {
        al: '',
        k1: '',
        k2: '',
        acd: '',
        aconst_title: 'A Constant',
        aconst: '',
        target_title: 'Target refraction',
        target: '',
        lt: '',
        cct: '',
        inputs_type: 'regular',
      },
      results_table_od: {
        selected: [],
        selected_power: null,
        selected_es: null,
        headers: [
          { text: 'IOL POWER (D)', value: 'power' },
          { text: 'REFRACTION (D)', value: 'es' },
        ],
        powers: [
          {
            id: 0,
            name: 'pm1',
            es: 'espm1',
            power: 'powerpm1',
          },
          {
            id: 1,
            name: 'pm05',
            es: 'espm05',
            power: 'powerpm05',
          },
          {
            id: 2,
            name: 'p0',
            es: 'esp0',
            power: 'powerp0',
          },
          {
            id: 3,
            name: 'p05',
            es: 'esp05',
            power: 'powerp05',
          },
          {
            id: 4,
            name: 'p1',
            es: 'esp1',
            power: 'powerp1',
          },
        ],
      },
      results_table_os: {
        selected: [],
        selected_power: null,
        headers: [
          { text: 'IOL POWER (D)', value: 'power' },
          { text: 'REFRACTION (D)', value: 'es' },
        ],
        powers: [
          {
            id: 0,
            name: 'pm1',
            es: 'espm1',
            power: 'powerpm1',
          },
          {
            id: 1,
            name: 'pm05',
            es: 'espm05',
            power: 'powerpm05',
          },
          {
            id: 2,
            name: 'p0',
            es: 'esp0',
            power: 'powerp0',
          },
          {
            id: 3,
            name: 'p05',
            es: 'esp05',
            power: 'powerp05',
          },
          {
            id: 4,
            name: 'p1',
            es: 'esp1',
            power: 'powerp1',
          },
        ],
      },
    }
  },
  mounted() {
    setTimeout(() => {
      this.loading = false
    }, 2000)

    // init last calc
    this.last_calc = this.glastCalc

    // init patient/kera/biom
    this.results_header.patientID.text = this.ginputs.patientID
    this.results_header.keratometric_index.text = this.ginputs.keratometric_index
    this.results_header.biometer.text = this.ginputs.biometer.text

    // init common inputs OD
    this.common_inputs_od.al = this.ginputs.al
    this.common_inputs_od.k1 = this.ginputs.k1
    this.common_inputs_od.k2 = this.ginputs.k2
    this.common_inputs_od.acd = this.ginputs.acd
    this.common_inputs_od.aconst = this.ginputs.aconst
    this.common_inputs_od.target = this.ginputs.target
    this.common_inputs_od.lt = this.ginputs.lt
    this.common_inputs_od.cct = this.ginputs.cct

    // init common inputs OS
    this.common_inputs_os.al = this.ginputs2.al
    this.common_inputs_os.k1 = this.ginputs2.k1
    this.common_inputs_os.k2 = this.ginputs2.k2
    this.common_inputs_os.acd = this.ginputs2.acd
    this.common_inputs_os.aconst = this.ginputs2.aconst
    this.common_inputs_os.target = this.ginputs2.target
    this.common_inputs_os.lt = this.ginputs2.lt
    this.common_inputs_os.cct = this.ginputs2.cct

    // init result table OD
    this.results_table_od.powers.forEach((power) => {
      const resultData = this.results[power.name]
      if (resultData) {
        power.es = resultData.es
        power.power = resultData.power
      }
    })
    // init result2 table
    this.results_table_os.powers.forEach((power) => {
      const resultData = this.results2[power.name]
      if (resultData) {
        power.es = resultData.es
        power.power = resultData.power
      }
    })
  },
  computed: {
    ...mapState([
      'results',
      'results2',
      'ginputs',
      'ginputs2',
      'appHeader',
      'glastCalc',
    ]),
  },
  methods: {
    print() {
      window.print()
    },
    submit_toric() {
      if (this.results_table_od.selected_power !== null) {
        this.$store.dispatch('updateInputsToric', this.results_table_od)
        this.$store.dispatch('updateLastCalc', 'regular_od')
      } else if (this.results_table_os.selected_power !== null) {
        this.$store.dispatch('updateInputsToric', this.results_table_os)
        this.$store.dispatch('updateLastCalc', 'regular_os')
      }
      this.$store.dispatch('updateToricCalcAllowed', true)
      this.$router.push('toric')
    },
  },
}
</script>
